import { useIntl } from 'react-intl';
import { FormatMessageFunc } from '../types';

export function useFormatMessage(): FormatMessageFunc {
    return useIntl().formatMessage;
}
